<template>
  <div class="appManagement">
    <div class="ac_left">
      <div class="find">
        <img src="../../../../assets/icon/appStore/find_icon.svg" />
        <span>发现</span>
      </div>
      <saveCard
        title="最近使用"
        :data="recentUse"
        :icon="require('../../../../assets/icon/appStore/history2_icon.svg')"
        :type="1"
        @saveClick="openApp"
      />
      <saveCard
        title="我的收藏"
        :icon="require('../../../../assets/icon/appStore/collect2_icon.svg')"
        :data="collect"
        :type="0"
        @saveClick="openApp"
      />
    </div>
    <div class="ac_right">
      <div class="ac_header">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-show="false"
          style="position: absolute;right: 15px;"
          @click="addApp"
          >添加应用</el-button
        >
        <div class="ac_h_banner" v-if="controlsObj && controlsObj.bannerUrl">
          <img :src="controlsObj.bannerUrl" alt="banner图" />
        </div>
        <div class="ac_h_bottom">

          <div class="ac_h_b_selectList">
            <div>
              <el-select
              v-model="selectJuri"
              placeholder="请选择显示范围"
              @change="changeSelectType"
              style="width: 120px;margin-right: 10px;"
            >
              <el-option
                v-for="item in selectList"
                :key="item.index"
                :label="item.label"
                :value="item.index"
              ></el-option>
            </el-select>
            <el-select
              v-model="selectLabel"
              placeholder="请选择类型"
              @change="changeSelectType"
              style="width: 110px;margin-right: 10px;"
            >
              <el-option
                v-for="item in labelSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-select
              v-model="statusType"
              placeholder="请选择状态"
              @change="changeSelectType"
              style="width: 110px;margin-right: 10px;"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            </div>

            <div><el-input
              v-model="searchText"
              style="width: 250px;margin-right: 10px;"
              placeholder="请输入应用名称"
              @keyup.enter.native="getData"
            >
              <i
                slot="suffix"
                class="searchInputIcon el-icon-search"
                @click="getData"
              ></i>
            </el-input>
            <!-- <el-button
              type="primary"
              style="margin-left: 10px;"
              icon="el-icon-search"
              @click="getData"
            ></el-button> -->
            <el-button type="primary" @click="selectApp()">发布应用</el-button></div>
          </div>

          <div class="ac_h_b_typeList">
            <span
              :class="{ ac_h_b_typeList_active: showType === '' }"
              @click="changeType('')"
              >全部</span
            >
            <span
              v-for="item in typeList"
              :key="item.id"
              :class="{ ac_h_b_typeList_active: showType === item.id }"
              @click="changeType(item.id)"
              >{{ item.name }}</span
            >
          </div>
        </div>
      </div>

      <div class="ac_content">
        <div
          class="ac_c_item"
          v-if="showType !== '' && !getDataLoading"
          v-for="(item, index) in dataList"
          :key="item.id"
        >
          <div class="ac_c_i_top" @click="openApp(item)">
            <div class="ac_c_i_t_left">
              <img v-if="item.json.icon" :src="item.json.icon" />
              <svg
                v-else
                t="1732605901531"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4275"
                width="200"
                height="200"
              >
                <path
                  d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
                  fill="#2C6DD2"
                  p-id="4276"
                ></path>
                <path
                  d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
                  fill="#20C997"
                  p-id="4277"
                ></path>
              </svg>
            </div>
            <div class="ac_c_i_t_right">
              <div class="ac_c_i_t_r_top">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="item.name"
                  placement="top"
                >
                  <span>{{ item.name }}</span>
                </el-tooltip>

                <div class="ac_c_i_t_popover" v-if="showMenu(item)">
                  <div
                    class="ac_c_i_t_p_box"
                    v-if="editAppCard === item.id"
                    v-click-outside="handleBlur"
                  >
                    <div
                      @click.stop="copyApp(item)"
                      v-if="item.json && item.json.copy === '1'"
                    >
                      <img
                        src="../../../../assets/icon/appStore/copy.svg"
                        alt=""
                      />
                      <span>复制</span>
                    </div>
                    <div
                      @click.stop="updateApp(item)"
                      v-if="item.userid === userId"
                    >
                      <img
                        src="../../../../assets/icon/appStore/edit.svg"
                        alt=""
                      />
                      <span>修改</span>
                    </div>
                    <div
                      @click.stop="delApp(item)"
                      v-if="item.userid === userId"
                    >
                      <img
                        src="../../../../assets/icon/appStore/del.svg"
                        alt=""
                      />
                      <span>取消发布</span>
                    </div>
                  </div>
                  <svg
                    t="1732786015570"
                    @click.stop="updateCard(item.id)"
                    :style="
                      `transform: rotate(${
                        editAppCard === item.id ? '0deg' : '90deg'
                      });background-color:${
                        editAppCard === item.id ? '#F3F7FD' : '#fff'
                      }`
                    "
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="9199"
                    width="200"
                    height="200"
                  >
                    <path
                      d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                      fill="#111111"
                      p-id="9200"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="ac_c_i_t_r_center">
                <span>@{{ item.username }}</span>
                <div v-if="item.label === 'workflow'">
                  <img
                    src="../../../../assets/icon/appStore/workflow.svg"
                    alt=""
                  />
                  工作流
                </div>
                <div v-if="item.label === 'agent'">
                  <img
                    src="../../../../assets/icon/appStore/agent.svg"
                    alt=""
                  />
                  智能体
                </div>
              </div>
              <div class="ac_c_i_t_r_bottom">
                {{ item.detail }}
              </div>
            </div>
          </div>
          <div class="ac_c_i_bottom" @click="openApp(item)">
            <div class="ac_c_i_b_left">
              <el-tooltip
                class="item"
                effect="light"
                content="被复制数"
                placement="top"
              >
                <div>
                  <img src="../../../../assets/icon/appStore/user_copy.svg" />
                  <span>{{ item.copyCount }}</span>
                </div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="light"
                :content="item.likeId ? '取消点赞' : '点赞'"
                placement="top"
              >
                <div>
                  <img
                    :src="
                      require('../../../../assets/icon/appStore/praise_default.svg')
                    "
                    v-if="!item.likeId"
                    style="cursor: pointer;"
                    @click.stop="praiseFn(item, 0)"
                  />
                  <img
                    :src="
                      require('../../../../assets/icon/appStore/praise_active.svg')
                    "
                    v-else
                    style="cursor: pointer;"
                    @click.stop="praiseFn(item, 1)"
                  />
                  <span>{{ item.likeCount }}</span>
                </div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="light"
                :content="item.collectId ? '取消收藏' : '收藏'"
                placement="top"
              >
                <div>
                  <img
                    src="../../../../assets/icon/appStore/collect_default.svg"
                    v-if="!item.collectId"
                    style="cursor: pointer;"
                    @click.stop="collectFn(item, 0)"
                  />
                  <img
                    src="../../../../assets/icon/appStore/collect_active.svg"
                    v-else
                    style="cursor: pointer;"
                    @click.stop="collectFn(item, 1)"
                  />
                  <span>{{ item.collectCount }}</span>
                </div>
              </el-tooltip>
            </div>
            <div class="ac_c_i_b_right" v-if="item.json.status">
              <span class="ac_c_i_b_r_type2" v-if="item.json.status === '1'"
                >测试</span
              >
              <span class="ac_c_i_b_r_type1" v-if="item.json.status === '2'"
                >稳定</span
              >
            </div>
          </div>
        </div>

        <div class="ac_c_typeCard" v-if="showType == ''">
          <div class="ac_c_tc_item" v-for="(item2, index2) in typeList">
            <div class="ac_c_tc_i_top">
              <div>{{ item2.name }}</div>

              <span @click="changeType(item2.id)"
                >查看更多
                <img src="../../../../assets/icon/appStore/arrow.svg" />
              </span>
            </div>
            <div class="ac_c_tc_i_bottom">
              <div
                class="ac_c_item"
                v-if="index < 8"
                v-for="(item, index) in dataList.filter(
                  i => i.type == item2.id
                )"
                :key="item.id"
              >
                <div class="ac_c_i_top" @click="openApp(item)">
                  <div class="ac_c_i_t_left">
                    <img v-if="item.json.icon" :src="item.json.icon" />
                    <svg
                      v-else
                      t="1732605901531"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="4275"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
                        fill="#2C6DD2"
                        p-id="4276"
                      ></path>
                      <path
                        d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
                        fill="#20C997"
                        p-id="4277"
                      ></path>
                    </svg>
                  </div>
                  <div class="ac_c_i_t_right">
                    <div class="ac_c_i_t_r_top">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="item.name"
                        placement="top"
                      >
                        <span>{{ item.name }}</span>
                      </el-tooltip>

                      <div class="ac_c_i_t_popover" v-if="showMenu(item)">
                        <div
                          class="ac_c_i_t_p_box"
                          v-if="editAppCard === item.id"
                          v-click-outside="handleBlur"
                        >
                          <div
                            @click.stop="copyApp(item)"
                            v-if="item.json && item.json.copy === '1'"
                          >
                            <img
                              src="../../../../assets/icon/appStore/copy.svg"
                              alt=""
                            />
                            <span>复制</span>
                          </div>
                          <div
                            @click.stop="updateApp(item)"
                            v-if="item.userid === userId"
                          >
                            <img
                              src="../../../../assets/icon/appStore/edit.svg"
                              alt=""
                            />
                            <span>修改</span>
                          </div>
                          <div
                            @click.stop="delApp(item)"
                            v-if="item.userid === userId"
                          >
                            <img
                              src="../../../../assets/icon/appStore/del.svg"
                              alt=""
                            />
                            <span>取消发布</span>
                          </div>
                        </div>
                        <svg
                          t="1732786015570"
                          @click.stop="updateCard(item.id)"
                          :style="
                            `transform: rotate(${
                              editAppCard === item.id ? '0deg' : '90deg'
                            });background-color:${
                              editAppCard === item.id ? '#F3F7FD' : '#fff'
                            }`
                          "
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="9199"
                          width="200"
                          height="200"
                        >
                          <path
                            d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                            fill="#111111"
                            p-id="9200"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div class="ac_c_i_t_r_center">
                      <span>@{{ item.username }}</span>
                      <div v-if="item.label === 'workflow'">
                        <img
                          src="../../../../assets/icon/appStore/workflow.svg"
                          alt=""
                        />
                        工作流
                      </div>
                      <div v-if="item.label === 'agent'">
                        <img
                          src="../../../../assets/icon/appStore/agent.svg"
                          alt=""
                        />
                        智能体
                      </div>
                    </div>
                    <div class="ac_c_i_t_r_bottom">
                      {{ item.detail }}
                    </div>
                  </div>
                </div>
                <div class="ac_c_i_bottom" @click="openApp(item)">
                  <div class="ac_c_i_b_left">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="被复制数"
                      placement="top"
                    >
                      <div>
                        <img
                          src="../../../../assets/icon/appStore/user_copy.svg"
                        />
                        <span>{{ item.copyCount }}</span>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.likeId ? '取消点赞' : '点赞'"
                      placement="top"
                    >
                      <div>
                        <img
                          :src="
                            require('../../../../assets/icon/appStore/praise_default.svg')
                          "
                          v-if="!item.likeId"
                          style="cursor: pointer;"
                          @click.stop="praiseFn(item, 0)"
                        />
                        <img
                          :src="
                            require('../../../../assets/icon/appStore/praise_active.svg')
                          "
                          v-else
                          style="cursor: pointer;"
                          @click.stop="praiseFn(item, 1)"
                        />
                        <span>{{ item.likeCount }}</span>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.collectId ? '取消收藏' : '收藏'"
                      placement="top"
                    >
                      <div>
                        <img
                          src="../../../../assets/icon/appStore/collect_default.svg"
                          v-if="!item.collectId"
                          style="cursor: pointer;"
                          @click="collectFn(item, 0)"
                        />
                        <img
                          src="../../../../assets/icon/appStore/collect_active.svg"
                          v-else
                          style="cursor: pointer;"
                          @click="collectFn(item, 1)"
                        />
                        <span>{{ item.collectCount }}</span>
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="ac_c_i_b_right" v-if="item.json.status">
                    <span
                      class="ac_c_i_b_r_type2"
                      v-if="item.json.status === '1'"
                      >测试</span
                    >
                    <span
                      class="ac_c_i_b_r_type1"
                      v-if="item.json.status === '2'"
                      >稳定</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="ac_c_empty"
                v-if="dataList.filter(i => i.type == item2.id).length === 0"
              >
                <span>暂无数据...</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="ac_c_item"
          v-for="(item, index) in dataList"
          :key="item.id"
          @click="openApp(item)"
        >
          <div class="ac_c_i_top">
            <div class="ac_c_i_t_left">
              <svg
                v-if="
                  isImageOrSvg(
                    typeof item.json == 'object' ? item.json.icon : ''
                  ) === 0
                "
                t="1732605901531"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4275"
                width="200"
                height="200"
              >
                <path
                  d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
                  fill="#2C6DD2"
                  p-id="4276"
                ></path>
                <path
                  d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
                  fill="#20C997"
                  p-id="4277"
                ></path>
              </svg>
              <span
                v-if="
                  isImageOrSvg(
                    typeof item.json == 'object' ? item.json.icon : ''
                  ) === 1
                "
                v-html="item.json.icon"
              ></span>
              <el-image
                v-if="
                  isImageOrSvg(
                    typeof item.json == 'object' ? item.json.icon : ''
                  ) === 2
                "
                style="width: 100%; height: 100%"
                :src="item.json.icon"
                fit="cover"
              ></el-image>
            </div>
            <div class="ac_c_i_t_right">
              <div>{{ item.name }}</div>
              <span>{{ item.label}}</span>
            </div>
            <div class="ac_c_i_t_popover">
              <div
                class="ac_c_i_t_p_box"
                v-if="editAppCard === item.id"
                v-click-outside="handleBlur"
              >
                <div
                  @click.stop="cancelCollectApp(item)"
                  v-if="collect.map(i => i.id).includes(item.id)"
                >
                  取消收藏
                </div>
                <div @click.stop="collectApp(item)" v-else>收藏</div>
                <div
                  @click.stop="copyApp(item)"
                  v-if="item.json && item.json.copy === '1'"
                >
                  复制
                </div>
                <div
                  @click.stop="updateApp(item)"
                  v-if="item.userid === userId"
                >
                  修改
                </div>
                <div @click.stop="delApp(item)" v-if="item.userid === userId">
                  删除
                </div>
              </div>
              <svg
                t="1732786015570"
                @click.stop="updateCard(item.id)"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9199"
                width="200"
                height="200"
              >
                <path
                  d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
                  fill="#111111"
                  p-id="9200"
                ></path>
              </svg>
            </div>
          </div>
          <div class="ac_c_i_bottom">
            <div>{{ item.detail }}</div>
          </div>
        </div> -->
        <div class="ac_c_empty" v-if="dataList.length === 0 && showType !== ''">
          <span>暂无数据...</span>
        </div>
      </div>
    </div>
    <addAppDialog
      ref="addAppDialogRef"
      :typeList="typeList"
      @success="addAppSuccess"
    />
    <selectAppDialog ref="selectAppDialogRef" @success="selectAppSuccess" />
    <releaseAppDialog
      ref="releaseAppDialogRef"
      :typeList="typeList"
      @success="releaseAppSuccess"
    />
  </div>
</template>

<script>
const clickOutside = {
  bind(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function(event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
        binding.value(event);
      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener("click", el.clickOutsideEvent);
  }
};
import addAppDialog from "../dialog/addAppDialog.vue";
import saveCard from "../components/saveCard.vue";
import selectAppDialog from "../dialog/selectAppDialog.vue";
import releaseAppDialog from "../dialog/releaseAppDialog.vue";
// import collectCard from "./dialog/collectCard.vue";
// import recentUseCard from "./dialog/recentUseCard.vue";
export default {
  components: {
    addAppDialog,
    saveCard,
    selectAppDialog,
    releaseAppDialog
    // collectCard,
    // recentUseCard
  },
  directives: {
    "click-outside": clickOutside // 注册自定义指令
  },
  data() {
    return {
      showType: "",
      searchText: "",
      selectJuri: 3,
      selectLabel: "",
      typeList: [],
      selectList: [
        { index: 3, label: "所有组织" },
        { index: 2, label: "组织内" },
        { index: 1, label: "我的" }
        // { index: 98,label:"已发布"},
        // { index: 99,label:"未发布"},
      ],
      statusList: [
        { value: "", label: "所有状态" },
        { value: 1, label: "测试" },
        { value: 2, label: "稳定" }
      ],
      statusType: "",
      labelSelect: [
        { value: "", label: "所有类型" },
        { value: "agent", label: "智能体" },
        { value: "workflow", label: "工作流" }
      ],
      userId: this.$route.query["userid"],
      org: this.$route.query["org"],
      oid: this.$route.query["oid"],
      getDataLoading: false,
      dataList: [],
      recentUse: [],
      collect: [],
      editAppCard: null,
      bannerObj: null,
      userName: null,
      controlsObj: null
      // region:this.$route.query["region"]
    };
  },
  computed: {
    showMenu() {
      return data => {
        let _result = false;
        if (data && this.userId) {
          if (
            data.userid === this.userId ||
            (data.json && data.json.copy === "1")
          ) {
            _result = true;
          }
        }
        return _result;
      };
    },
    region() {
      let _result = "cn";
      let query = this.$route.query["region"];
      if (query && (query == "cn" || query == "hk" || query == "all")) {
        _result = query;
      }
      return _result;
    }
  },
  watch: {
    searchText: {
      immediate: false,
      handler() {
        if (this.searchText === "") {
          this.getData();
        }
      }
    }
  },
  methods: {
    changeType(newIndex) {
      let flag = this.showType === newIndex;
      this.showType = newIndex;
      if (!flag) {
        this.getData();
      }
    },
    changeSelectType() {
      this.getData();
    },
    getData() {
      this.getDataLoading = true;
      let params = {
        uid: this.userId, //用户ID
        name: this.searchText, //应用名称搜索
        label: this.selectLabel, //应用的标签搜索
        type: this.showType, //应用的类型
        juri: this.selectJuri, //应用权限 1:我的  2：组织内  3：所有人
        stand: this.region ? this.region : "cn", //cn站还是hk站
        status: this.statusType,
        exportType:(this.controlsObj&&this.controlsObj.exportTypeList&&this.controlsObj.exportTypeList.length>0)?this.controlsObj.exportTypeList.join(','):"",
      };

      this.ajax
        .get(this.$store.state.api + "select_appStore_exportType", params)
        .then(res => {
          this.getDataLoading = false;
          let _data = res.data[0];
          if (_data.length > 0) {
            _data.forEach(i => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            this.dataList = _data;
          } else {
            this.dataList = [];
          }
        })
        .catch(err => {
          this.getDataLoading = false;
          console.log(err);
          this.$message.error("获取应用失败");
        });
    },
    addApp() {
      this.$refs.addAppDialogRef.open({ type: 1 });
    },
    selectApp() {
      this.$refs.selectAppDialogRef.open();
    },
    selectAppSuccess(data) {
      if (data) {
        this.$refs.selectAppDialogRef.close();
        this.$refs.releaseAppDialogRef.open({
          form: {
            id: data.id,
            name: data.name,
            label: data.label,
            detail: data.detail,
            url: data.url,
            type: data.type,
            juri: data.juri,
            stand: data.stand,
            json: data.json
          }
        });
      }
    },
    updateApp(data) {
      this.$refs.addAppDialogRef.open({
        type: 2,
        form: {
          id: data.id,
          name: data.name,
          label: data.label,
          detail: data.detail,
          url: data.url,
          type: data.type,
          juri: data.juri,
          stand: data.stand,
          json: data.json
        }
      });
    },
    // 收藏APP
    // collectApp(item) {
    //   this.editAppCard = null;
    //   this.insertSave(item, 0);
    // },
    //复制app
    async copyApp(item) {
      this.$confirm(`确定复制《${item.name}》这个应用至我的列表吗？`, "复制", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async e => {
          let _status = await this.copyAgentOrWorkflow(item);
          if (_status == 1) {
            this.$message.success("复制成功,已添加至我的工作流列表。");
          } else if (_status == 2) {
            this.$message.success("复制成功,已添加至我的智能体列表。");
          } else if (_status == 3) {
            this.$message.error("复制失败，该应用无内容");
          } else if (_status == 0) {
            this.$message.error("复制失败");
          }
          // console.log(item);
          // let url = item.url;
          // let id =
          //   this.queryURLParams(url, "id") ||
          //   item.url.split("/")[item.url.split("/").length - 1];
          // if (!id) return this.$message.error("复制失败，未找到对应id");
          // if ((item.label = "workflow")) {
          //   this.ajax
          //     .get(`https://appapi.cocorobo.cn/api/agents/muti_agent/${id}`)
          //     .then(res => {
          //       let _data = res.data;
          //       let _idList = [];
          //       if (_data["dialoguePublishDataId"])
          //         _idList.push(_data["dialoguePublishDataId"]);
          //       if (_data["immersivePublishDataId"])
          //         _idList.push(_data["immersivePublishDataId"]);
          //       if (_data["cardPublishDataId"])
          //         _idList.push(_data["cardPublishDataId"]);
          //       if (_idList.length > 0) {
          //       } else {
          //         console.log("该应用无id");
          //       }
          //     });
          // } else if ((item.label = "agent")) {
          //   let _idList = [id];
          // }
          // this.ajax.get(`https://appapi.cocorobo.cn/api/agents/muti_agent/${id}`).then(res=>{
          //   let _data = res.data;
          //   console.log(_data)
          //   let dialoguePublishDataId = _data['dialoguePublishDataId'];
          //   let immersivePublishDataId = _data['immersivePublishDataId'];
          //   let cardPublishDataId = _data['cardPublishDataId'];
          //   console.log('dialoguePublishDataId',dialoguePublishDataId);
          //   console.log('immersivePublishDataId',immersivePublishDataId);
          //   console.log('cardPublishDataId',cardPublishDataId)
          // })
          // let params = [
          //   {
          //     name: `${item.name}_copy`, //app名称
          //     userid: this.userId, //创建的用户ID
          //     label: item.label, //app标签
          //     detail: item.detail, //app简介
          //     url: item.url, //app链接
          //     type: item.type, //app类型
          //     juri: "1", //app权限 1:我的 2:组织 3:所有人
          //     stand: "cn", //语言
          //     json: JSON.stringify(item.json) //其他信息
          //   }
          // ];
          // this.ajax
          //   .post(this.$store.state.api + "insert_appStore", params)
          //   .then(res => {
          //     if (res.data) {
          //       this.$message.success("复制成功,已添加至我的列表。");
          //       this.getData();
          //       this.insertSave(item, 3);
          //     } else {
          //       this.$message.error("复制失败");
          //     }
          //   })
          //   .catch(err => {
          //     console.log(err);
          //     this.$message.error("复制失败");
          //   });
        })
        .catch(_ => {
          console.log("取消复制");
        });
    },
    async copyAgentOrWorkflow(item) {
      return new Promise(async resolve => {
        let url = item.url;
        let id =
          this.queryURLParams(url, "id") ||
          item.url.split("/")[item.url.split("/").length - 1];
        if (!id) {
          console.log("该链接无对应id");
          return resolve(3);
          // return this.$message.error("复制失败，未找到对应id")
        }
        console.log(item);
        if (item.label == "workflow") {
          //复制工作流
          console.log("复制工作流");
          this.ajax
            .get(`https://appapi.cocorobo.cn/api/agents/muti_agent/${id}`)
            .then(async res => {
              let _data = res.data;

              let _modes = 'wu';

              if(item.json.modes){
                _modes = item.json.modes[0];
              }

              console.log(_data);
              let _idList = [];
              if (_data["dialoguePublishDataId"] && (_modes=='wu' || _modes == '0'))
                _idList.push(_data["dialoguePublishDataId"]);
              if (_data["immersivePublishDataId"] && (_modes=='wu' || _modes == '2'))
                _idList.push(_data["immersivePublishDataId"]);
              if (_data["cardPublishDataId"] && (_modes=='wu' || _modes == '1'))
                _idList.push(_data["cardPublishDataId"]);
              if (_idList.length <= 0) {
                resolve(3);
                return console.log("该应用无id");
              }
              // /api/agents/copy_mutiAgent
              this.ajax
                .post("https://appapi.cocorobo.cn/api/agents/copy_mutiAgent", {
                  ids: _idList,
                  userId: this.userId,
                  username: this.userName
                    ? this.userName
                    : await this.getUserName(this.userId)
                })
                .then(_ => {
                  resolve(1);
                })
                .catch(e => {
                  console.log(e);
                  resolve(0);
                });
            });
        } else if (item.label == "agent") {
          //复制智能体
          console.log("复制智能体");
          this.ajax
            .get(`https://appapi.cocorobo.cn/api/agents/agent/parent/${id}`)
            .then(async res => {
              let _id = res.data.id;
              if (_id) {
                let _idList = [_id];
                this.ajax
                  .post("https://appapi.cocorobo.cn/api/agents/copy_agent", {
                    ids: _idList,
                    userId: this.userId,
                    username: this.userName
                      ? this.userName
                      : await this.getUserName(this.userId)
                  })
                  .then(_ => {
                    resolve(2);
                  })
                  .catch(e => {
                    console.log(e);
                    resolve(0);
                  });
              }
              console.log(res);
            })
            .catch(e => {
              console.log(e);
              resolve(0);
              // this.$message.error("")
            });
          // let _idList = [id];
          // this.ajax.post('https://appapi.cocorobo.cn/api/agents/copy_agent',{
          //   ids: _idList,
          //   userId: this.userId,
          //   username: this.userName?this.userName:await this.getUserName(this.userId),
          // }).then(_=>{
          //   resolve(2);
          // }).catch(e=>{
          //   console.log(e)
          //   resolve(0)
          // })
        }
      });
    },
    // 取消收藏
    cancelCollectApp(item) {
      this.editAppCard = null;
      let _data = this.collect.find(i => i.id === item.id);
      if (_data) {
        let params = [
          {
            sid: _data.sid
          }
        ];
        this.ajax
          .post(this.$store.state.api + "delete_appStoreSave", params)
          .then(res => {
            if (res.data) {
              this.$message.success("取消收藏成功");
            }
            this.getCollect();
          })
          .catch(e => {
            console.log(e);
            this.$message.error("取消收藏失败");
            this.getCollect();
          });
      } else {
        this.$message.error("取消收藏失败");
        this.getCollect();
      }
    },
    updateCard(id) {
      if (this.editAppCard === id) return (this.editAppCard = null);
      this.editAppCard = id;
    },
    handleBlur() {
      this.updateCard(null);
    },
    addAppSuccess(data, type) {
      if (type === 1) {
        //添加
        let params = [
          {
            name: data.name, //app名称
            userid: this.userId, //创建的用户ID
            label: data.label, //app标签
            detail: data.detail, //app简介
            url: data.url, //app链接
            type: data.type, //app类型
            juri: data.juri, //app权限 1:我的 2:组织 3:所有人
            stand: this.region ? this.region : "cn", //语言
            json: JSON.stringify(data.json) //其他信息
          }
        ];
        this.ajax
          .post(this.$store.state.api + "insert_appStore", params)
          .then(res => {
            if (res.data[0][0]["id"]) {
              this.$message.success("添加成功");
              this.$refs.addAppDialogRef.close(true);
              this.getData();
            } else {
              this.$message.error("添加失败");
              this.$refs.addAppDialogRef.loading = false;
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error("添加失败");
          });
      } else if (type === 2) {
        let params = [
          {
            aid: data.id,
            name: data.name, //app名称
            userid: this.userId, //创建的用户ID
            label: data.label, //app标签
            detail: data.detail, //app简介
            url: data.url, //app链接
            type: data.type, //app类型
            juri: data.juri, //app权限 1:我的 2:组织 3:所有人
            stand: this.region ? this.region : "cn", //语言
            json: JSON.stringify(data.json) //其他信息
          }
        ];
        this.ajax
          .post(this.$store.state.api + "update_appStore", params)
          .then(res => {
            if (res.data) {
              this.$message.success("修改成功");
              this.$refs.addAppDialogRef.close(true);
              this.getData();
            } else {
              this.$message.error("修改失败");
              this.$refs.addAppDialogRef.loading = false;
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error("修改失败");
          });
      }
    },
    releaseAppSuccess(data) {
      this.$refs.releaseAppDialogRef.loading = true;
      let params = [
        {
          aid: data.id,
          name: data.name, //app名称
          userid: this.userId, //创建的用户ID
          label: data.label, //app标签
          detail: data.detail, //app简介
          url: data.url, //app链接
          type: data.type, //app类型
          juri: data.juri, //app权限 1:我的 2:组织 3:所有人
          stand: this.region ? this.region : "cn", //语言
          json: JSON.stringify(data.json) //其他信息
        }
      ];
      this.ajax
        .post(this.$store.state.api + "update_appStore", params)
        .then(res => {
          if (res.data) {
            this.$message.success("发布成功");
            this.$refs.releaseAppDialogRef.close(true);
          } else {
            this.$message.error("发布失败");
            this.$refs.releaseAppDialogRef.loading = false;
          }
          this.getData();
        })
        .catch(err => {
          console.log(err);
          this.$message.error("修改失败");
        });
    },
    getTypeList() {
      let params = {
        suserid: this.userId, //用户ID
        sorg: this.org,
        soid: this.oid,
        sstand: this.region ? this.region : "cn",
        exportType:(this.controlsObj&&this.controlsObj.exportTypeList&&this.controlsObj.exportTypeList.length>0)?this.controlsObj.exportTypeList.join(','):"",
      };

      this.ajax
        .get(this.$store.state.api + "select_appStoreType_exceptType", params)
        .then(res => {
          let data = res.data[0];
          if (data.length > 0) {
            // data.forEach(i => {
            //   if (i.open == undefined) {
            //     i.open = true;
            //   }
            // });
            this.typeList = data;
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("获取应用类型失败");
        });
    },
    async openApp(item, type = 0) {
      window.open(item.url, "_blank");
      if (
        !(this.recentUse.length > 0 && item.id === this.recentUse[0].id) &&
        type === 0
      ) {
        await this.insertSave(item, 1);
        this.getRecentUse();
      }
    },

    resetData() {
      this.searchText = "";
      this.selectJuri = 3;
      this.showType = "";
      this.getData();
    },
    getRecentUse() {
      let params = {
        uid: this.userId,
        type: 1,
        limit: 10
      };

      this.ajax
        .get(this.$store.state.api + "select_appStoreSave", params)
        .then(res => {
          let data = res.data[0];
          if (data.length > 0) {
            data.forEach(i => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            this.recentUse = data;
          } else {
            this.recentUse = [];
          }
        })
        .catch(err => {
          console.log(err);
          console.log("获取最近使用失败");
          // this.$message.error("获取收藏应用失败")
        });
    },
    getCollect() {
      let params = {
        uid: this.userId,
        type: 0,
        limit: 0
      };
      this.ajax
        .get(this.$store.state.api + "select_appStoreSave", params)
        .then(res => {
          let data = res.data[0];
          if (data.length > 0) {
            data.forEach(i => {
              if (i.json) {
                i.json = JSON.parse(i.json);
              }
            });
            this.collect = data;
          } else {
            this.collect = [];
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("获取收藏应用失败");
        });
    },
    insertSave(item, type) {
      return new Promise(resolve => {
        let params = [
          {
            uid: this.userId,
            type: type,
            aid: item.id,
            json: ""
          }
        ];

        this.ajax
          .post(this.$store.state.api + "insert_appStoreSave", params)
          .then(res => {
            if (res.data) {
              if (type === 1) {
                resolve(1);
              }
            }
          })
          .catch(err => {
            resolve(0);
            console.log(err);
          });
      });
    },
    delApp(item) {
      this.$confirm(
        `确定要取消发布《${item.name}》这个应用吗?`,
        `确定取消发布应用`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async() => {
          console.log(item.json)
          let status = await this.delAgentOrWorkflow(item);

          if(status==0){
            this.$message.success("取消发布成功");
            this.getData();
          }else if(status==1){
            this.$message.error("取消发布失败");
            this.getData();
          }else if(status==2){
  let params = [
           {
             uid: this.userId,
             aid: item.id
           }
         ];
         this.ajax
           .post(this.$store.state.api + "delete_appStore", params)
           .then(res => {
             if (res.data) {
               this.$message.success("取消发布成功");
               this.getData();
             } else {
               this.$message.error("取消发布失败");
             }
             if (this.collect.findIndex(i => i.id == item.id) != -1) {
               this.getCollect();
             }
           })
           .catch(err => {
             console.log(err);
             this.$message.error("取消发布失败");
           });
          }

        })
        .catch(() => {
          console.log("取消发布失败");
        });
    },
    async delAgentOrWorkflow(item){
      return new Promise(async resolve => {
        let url = item.url;
        let id =
          this.queryURLParams(url, "id") ||
          item.url.split("/")[item.url.split("/").length - 1];
        if (!id) {
          console.log("该链接无对应id");
          return resolve(3);
          // return this.$message.error("复制失败，未找到对应id")
        }
        if (item.label == "workflow") {
          //复制工作流
          if(item.json.modes){
            let params = {
              status:0,
              modes:item.json.modes
            }
            this.ajax.post(`https://appapi.cocorobo.cn/api/agents/cancelPublishMutiAgent/${id}`,params).then(res=>{
              let _msg = res.data.message;
              if(_msg="MutiAgent unpublished successfully"){
                resolve(0)
              }else{
                resolve(1)
              }
            }).catch(e=>{
              console.log(e);
              resolve(1)
            })
          }else{
            resolve(2);
          }

        } else if (item.label == "agent") {
          //复制智能体
          let params = {
            status: 0,
            modes: ["0"]
          }
          this.ajax.post(`https://appapi.cocorobo.cn/api/agents/cancelPublishAgent/${id}`,params).then(res=>{
            let _msg = res.data.message;
            if(_msg=='Agent unpublished successfully'){
              resolve(0)
            }else{
              resolve(1)
            }
          }).catch(e=>{
            console.log(e);
            resolve(1)
          })

        }
      });
    },
    changeShowPage(newPage) {
      this.$emit("changeShowCard", newPage);
    },
    getBanner() {
      let params = {
        uid: this.userId,
        oid: this.oid,
        org: this.org,
        type: 4
      };

      this.ajax
        .get(this.$store.state.api + "select_bannerByoidORorg", params)
        .then(res => {
          let _data = res.data[0];
          if (_data[0]) {
            this.bannerObj = _data[0];
          } else {
            this.bannerObj = null;
          }
        })
        .catch(e => {
          console.log("获取banner图失败");
          console.log(e);
        });
    },
    praiseFn(item, type = 0) {
      //点赞
      if (type === 0) {
        //点赞
        let params = [
          {
            uid: this.userId,
            type: 2,
            aid: item.id,
            json: ""
          }
        ];
        this.ajax
          .post(this.$store.state.api + "insert_appStoreSave", params)
          .then(res => {
            if (res.data) {
              let _likeId = res.data[0][0].id;
              this.dataList.find(i => i.id === item.id).likeCount += 1;
              this.dataList.find(i => i.id === item.id).likeId = _likeId;
              this.$message.success("点赞成功");
            }
          })
          .catch(e => {
            this.$message.error("点赞失败");
          });
      } else if (type === 1) {
        //取消点赞
        console.log("取消点赞👉：", item);
        let params = [
          {
            sid: item.likeId
          }
        ];
        this.ajax
          .post(this.$store.state.api + "delete_appStoreSave", params)
          .then(res => {
            if (res.data) {
              this.dataList.find(i => i.id === item.id).likeCount -= 1;
              this.dataList.find(i => i.id === item.id).likeId = "";
              this.$message.success("取消点赞成功");
            }
          })
          .catch(e => {
            console.log(e);
            this.$message.error("取消点赞失败");
          });
      }
    },
    collectFn(item, type = 0) {
      //收藏
      if (type === 0) {
        //收藏
        console.log("收藏👉：", item);
        let params = [
          {
            uid: this.userId,
            type: 0,
            aid: item.id,
            json: ""
          }
        ];
        this.ajax
          .post(this.$store.state.api + "insert_appStoreSave", params)
          .then(res => {
            if (res.data) {
              let _colletId = res.data[0][0].id;
              this.dataList.find(i => i.id === item.id).collectCount += 1;
              this.dataList.find(i => i.id === item.id).collectId = _colletId;
              this.$message.success("收藏成功");
            }
            this.getCollect();
          })
          .catch(e => {
            console.log(e);
            this.getCollect();
            this.$message.error("收藏失败");
          });
      } else if (type === 1) {
        //取消收藏
        console.log("取消收藏👉：", item);
        let params = [
          {
            sid: item.collectId
          }
        ];
        this.ajax
          .post(this.$store.state.api + "delete_appStoreSave", params)
          .then(res => {
            if (res.data) {
              this.dataList.find(i => i.id === item.id).collectCount -= 1;
              this.dataList.find(i => i.id === item.id).collectId = "";
              this.$message.success("取消收藏成功");
            }
            this.getCollect();
          })
          .catch(e => {
            console.log(e);
            this.$message.error("取消收藏失败");
            this.getCollect();
          });
      }
    },
    queryURLParams(url, paramName) {
      // 正则表达式模式，用于匹配URL中的参数部分。正则表达式的含义是匹配不包含 ?、&、= 的字符作为参数名，之后是等号和不包含 & 的字符作为参数值
      let pattern = /([^?&=]+)=([^&]+)/g;
      let params = {};

      // match用于存储正则匹配的结果
      let match;
      // while 循环和正则表达式 exec 方法来迭代匹配URL中的参数
      while ((match = pattern.exec(url)) !== null) {
        // 在字符串url中循环匹配pattern，并对每个匹配项进行解码操作，将解码后的键和值分别存储在key和value变量中
        let key = decodeURIComponent(match[1]);
        let value = decodeURIComponent(match[2]);

        if (params[key]) {
          if (Array.isArray(params[key])) {
            params[key].push(value);
          } else {
            params[key] = [params[key], value];
          }
        } else {
          // 参数名在 params 对象中不存在，将该参数名和对应的值添加到 params 对象中
          params[key] = value;
        }
      }

      if (!paramName) {
        // 没有传入参数名称, 返回含有所有参数的对象params
        return params;
      } else {
        if (params[paramName]) {
          return params[paramName];
        } else {
          return "";
        }
      }
    },
    getUserName(uid) {
      return new Promise(resolve => {
        let params = { uid: uid };
        this.ajax
          .get(this.$store.state.api + "getUser", params)
          .then(res => {
            let data = res.data[0][0];
            this.userName = data.username;
            resolve(data.username);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    async getAppStoreControl() {
      return new Promise(resolve => {
        let params = {
          uid: this.userId,
          org: this.org,
          oid: this.oid
        };

        let controlsObj = {
          logoUrl: "",
          bannerUrl:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2FFrame+30141733970358224.svg",
          exportTypeList: []
        };
        this.ajax
          .get(this.$store.state.api + "select_appStore_controls", params)
          .then(res => {
            let _data = res.data[0];
            if (_data[0]) {
              console.log(_data[0])
              controlsObj = JSON.parse(_data[0].json);
            }
            this.controlsObj = controlsObj;
            resolve();
          })
          .catch(err => {
            console.log(err)
            this.controlsObj = controlsObj;
            resolve();
          });
      });
    }
  },
  mounted() {
    this.getAppStoreControl().then(_=>{
      this.getTypeList();
      this.getData();
      this.getCollect();
      this.getRecentUse();
      // this.getBanner();
    })
  }
};
</script>

<style scoped>
.appManagement {
  width: 100vw;
  height: 100vh;
  background-color: #f2f4f7;
  margin: 0;
  overflow: auto;
  box-sizing: border-box;
  /* padding: 20px; */
  display: flex;
  justify-content: space-between;
}

.ac_left {
  /* width: 280px;
  min-width: 280px; */
  width: clamp(200px, 12vw, 280px);
  min-width: 200px;
  margin-right: 20px;
  height: 100%;
  /* border-radius: 5px; */
  background-color: #fff;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  box-sizing: border-box;
  padding: 10px;
  padding-left: 20px;
  overflow: auto;
}

.ac_left > .find {
  width: 100%;
  height: 45px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #f3f7fd;
  box-sizing: border-box;
  padding: 0 20px 0 10px;
  display: flex;
  align-items: center;
  /* box-shadow: 2px 2px 4px 0px #1D39830A; */
  box-shadow: 0px 0px 4px 2px #1d39830a;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  color: #000000e5;
}

.ac_left > .find > img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.ac_right {
  flex: 1;
  min-width: 800px;
  height: 100%;
  overflow: auto;
  display: flex;
  padding-right: 10px;
  padding-top: 10px;
  box-sizing: border-box;
  flex-direction: column;
}

.ac_header {
  width: 100%;
  height: auto;
  border-radius: 5px;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  background-color: none;
}

.ac_h_top {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
  border-bottom: 1px solid #eeeeee;

  position: relative;
  justify-content: center;
}

.ac_h_top > span {
  font-size: 22px;
  position: relative;
  margin-right: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ac_h_top > span > svg {
  width: 22px;
  height: 22px;
  fill: #1a1a1a;
  margin-right: 10px;
}

.ac_h_t_active {
  color: #0354d7;
}

.ac_h_t_active > svg {
  fill: #0354d7 !important;
}

/* .ac_h_t_active::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  border-radius: 4px;
  background-color: #409eff;
  left: 0;
  bottom: -5px;
} */

.ac_h_banner {
  width: 100%;
  height: clamp(100px, 25vh, 350px);
  /* height: 400px; */
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}

.ac_h_banner > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.ac_h_bottom {
  width: 100%;
  height: auto;
  padding: 10px 15px 10px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px #e7e7e7;
}





.ac_h_b_typeList {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.ac_h_b_typeList > span {
  font-size: 16px;
  margin-right: 30px;
  margin-top: 10px;
  margin-bottom: 5px;
  cursor: pointer;
}

.ac_h_b_typeList_active {
  color: #007aff;
  position: relative;
}

/*.ac_h_b_typeList_active::after {
  content: "";
  width: 80%;
  height: 5px;
  background-color: #007aff;
  border-radius: 4px;
  position: absolute;
  top: 110%;·
  left: 10%;
}*/

.ac_h_b_selectList {
  /* margin-left: 15px; */
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/*
@media screen and (max-width: 1200px) {
  .ac_h_bottom{
    flex-direction: column;
  }

  .ac_h_b_typeList{
    width: 100%;
    margin-bottom: 20px;
  }

  .ac_h_b_selectList{
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
} */


.ac_content {
  width: 100%;
  height: auto;
  margin-top: 10px;
  padding-bottom: 10px;
}

.ac_c_typeCard {
  width: 100%;
  height: auto;
}

.ac_c_item {
  width: calc(100% / 4 - (15px * 4) / 4);
  height: 260px;
  background-color: #fff;
  border-radius: 10px;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  box-sizing: border-box;
  padding: 15px;
  margin-right: 15px;
  margin-bottom: 15px;
  float: left;
  border: solid 1px #e7e7e7;
  transition: 0.2s;

  /* cursor: pointer; */
}

.ac_c_item:hover {
  box-shadow: 0px 8px 10px -5px #00000014;

  box-shadow: 0px 16px 24px 2px #0000000a;

  box-shadow: 0px 6px 30px 5px #0000000d;
}

@media screen and (min-width: 1400px) {
  .ac_c_item {
    width: calc(100% / 4 - (15px * 3) / 4) !important;
  }
  .ac_c_item:nth-child(4n) {
    margin-right: 0px !important;
    /* background-color: red; */
  }
}

@media screen and (max-width: 1380px) {
  .ac_c_item {
    width: calc(100% / 4 - (15px * 3) / 4) !important;
  }

  .ac_c_item:nth-child(4n) {
    margin-right: 0px !important;
  }

  /* .ac_c_item:nth-child(5n) {
    margin-right: 0 !important;
  } */
}

@media screen and (max-width: 1080px) {
  .ac_c_item {
    width: calc(100% / 3 - (15px * 2) / 3) !important;
  }

  .ac_c_item:nth-child(5n) {
    margin-right: 15px !important;
  }

  .ac_c_item:nth-of-type(4n) {
    margin-right: 15px !important;
  }

  .ac_c_item:nth-child(3n) {
    margin-right: 0 !important;
  }
}

.ac_c_empty {
  width: 100%;
  height: 40%;
  display: flex;
  box-sizing: border-box;
  /* padding-top: 2%; */
  justify-content: center;
  color: #a1a1a1;
  /* align-items: center; */
}

.ac_c_i_top {
  width: 100%;
  display: flex;
  height: calc(100% - 40px - 10px);
  cursor: pointer;
}

.ac_c_i_t_left {
  width: 80px;
  min-width: 80px;
  height: 80px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  /* padding: 10px; */
  margin-right: 10px;
}

.ac_c_i_t_left > svg {
  width: 100%;
  height: 80px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  box-sizing: border-box;
}

.ac_c_i_t_left > img {
  width: 100%;
  object-fit: cover;
  height: 80px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  box-sizing: border-box;
}

.ac_c_i_t_right {
  flex: 1;
  width: calc(100% - 100px - 10px);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ac_c_i_t_right > div {
  width: 100%;
}

.ac_c_i_t_r_top {
  height: 40px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: relative;
  font-weight: bold;
  box-sizing: border-box;
  padding-bottom: 2px;
}

.ac_c_i_t_r_top > span {
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
}

.ac_c_i_t_popover {
  width: 30px;
  height: 30px;
  /* position: absolute; */
  /* right: 0;
  top: 0; */
  z-index: 3;
}

.ac_c_i_t_popover svg {
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  padding: 2.5px;
  /* transform: rotate(90deg); */
  cursor: pointer;
  transition: 0.3s;
  border-radius: 4px;
}

.ac_c_i_t_p_box {
  position: absolute;
  height: auto;
  top: 100%;
  right: 0;
  padding: 8px;
  border-radius: 8px 8px 8px 8px;
  background-color: #fff;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); */
  width: auto;
  border: 1px solid #e7e7e7;
}

.ac_c_i_t_p_box > div {
  width: 80px;
  height: 30px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 0.7em;
  border-radius: 5px;
  font-weight: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.ac_c_i_t_p_box > div > img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.ac_c_i_t_p_box > div:hover {
  background-color: #f2f4f7;
}

.ac_c_i_t_r_center {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.ac_c_i_t_r_center > span {
  display: block;
  max-width: calc(100% - 80px);
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  color: #00000066;
  text-overflow: ellipsis;
}

.ac_c_i_t_r_center > div {
  width: 75px;
  height: 85%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: #f3f3f3;
  color: #00000066;
  border-radius: 3px;
}

.ac_c_i_t_r_center > div > img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.ac_c_i_t_r_bottom {
  max-width: 100%;
  max-height: calc(100% - 30px - 40px - 20px - 10px + 5px);
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #00000099;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.ac_c_i_bottom {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  border-top: solid 1px #e7e7e7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.ac_c_i_b_left {
  width: calc(100% - 60px);
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  overflow: auto;
  height: 100%;
}

.ac_c_i_b_left > div {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.ac_c_i_b_left > div > img {
  width: 22px;
  height: 22px;
}

.ac_c_i_b_left > div > span {
  margin-left: 5px;
  color: #00000099;
  cursor: default;
}

.ac_c_i_b_right {
  display: flex;
  align-items: center;
  width: 70px;
  height: 70%;
  justify-content: flex-end;
}

.ac_c_i_b_right > span {
  width: 60px;
  height: 80%;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.ac_c_i_b_r_type1 {
  background-color: #17c469;
  color: #fff;
}

.ac_c_i_b_r_type2 {
  background-color: #ffcf33;
  color: #000;
}

.searchInputIcon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 10px;
  right: 5px;
  font-size: 19px;
  cursor: pointer;
}

.ac_c_tc_item {
  width: 100%;
  height: auto;
}

.ac_c_tc_i_top {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 0 20px;
  /* background-color: red; */
}

.ac_c_tc_i_top > div {
  font-size: 26px;
}

.ac_c_tc_i_top > span {
  display: flex;
  align-items: center;
  color: #a2a2a2;
  font-size: 16px;
  cursor: pointer;
}

.ac_c_tc_i_top > span > img {
  width: 18px;
  height: 18px;
  margin-left: 5px;
  /*transform: rotate(90deg);*/
  transition: 0.3s;
}

/* .ac_c_i_top {
  width: 100%;
  height: 50px;
  display: flex;
  position: relative;
}

.ac_c_i_t_popover {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  top: 0;
}

.ac_c_i_t_popover svg {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.ac_c_i_t_p_box {
  position: absolute;
  height: auto;
  top: 100%;
  right: 0;
  padding: 8px;
  border-radius: 8px 0 8px 8px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  width: auto;
}

.ac_c_i_t_p_box > div {
  width: 80px;
  height: 30px;
  cursor: pointer;
  transition: 0.3s;
  font-weight: bold;
  font-size: 0.9em;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.ac_c_i_t_p_box > div:hover {
  background-color: #f2f4f7;
}

.ac_c_i_t_left {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  margin-right: 10px;
  box-sizing: border-box;
  padding: 5px;
}

.ac_c_i_t_left > svg {
  width: 100%;
  height: 100%;
}

.ac_c_i_t_left > span {
  width: 100%;
  height: 100%;
  display: block;
}

.ac_c_i_t_left > span >>> svg {
  width: 100%;
  height: 100%;
}

.ac_c_i_t_right {
  width: calc(100% - 60px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.ac_c_i_t_right > div {
  font-size: 1.4em;
  font-weight: bold;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ac_c_i_t_right > span {
  font-size: 1.1em;
  color: #8991a1;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ac_c_i_bottom {
  width: 100%;
  height: calc(100% - 60px);
  margin-top: 15px;
}

.ac_c_i_bottom > div {
  font-size: 1em;
  color: #8991a1;
  width: 100%;
  height: calc(100%);
  display: -webkit-box;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}

.ac_c_i_bottom > span {
  margin-top: 5px;
  font-size: 1em;
  color: #409eff;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/appStore/views/appManagement.vue